/* global System */
// register component(s) with react habitat

export default { Brand: () => System.import('./index') }
